/**
 * @generated SignedSource<<91f5daa121d37f08d02a116d1badb909>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "accountName"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "accountNumber"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "activeOnly"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "direction"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "first"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "floatProblemOnly"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "offset"
},
v7 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "orderBy"
},
v8 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "outstandingSOOnly"
},
v9 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "resellerAccountId"
},
v10 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "accountname",
        "variableName": "accountName"
      },
      {
        "kind": "Variable",
        "name": "accountnumber",
        "variableName": "accountNumber"
      },
      {
        "kind": "Variable",
        "name": "activeonly",
        "variableName": "activeOnly"
      },
      {
        "kind": "Variable",
        "name": "direction",
        "variableName": "direction"
      },
      {
        "kind": "Variable",
        "name": "first",
        "variableName": "first"
      },
      {
        "kind": "Variable",
        "name": "floatproblemonly",
        "variableName": "floatProblemOnly"
      },
      {
        "kind": "Variable",
        "name": "offset",
        "variableName": "offset"
      },
      {
        "kind": "Variable",
        "name": "orderby",
        "variableName": "orderBy"
      },
      {
        "kind": "Variable",
        "name": "outstandingsoonly",
        "variableName": "outstandingSOOnly"
      },
      {
        "kind": "Variable",
        "name": "reselleraccountid",
        "variableName": "resellerAccountId"
      }
    ],
    "concreteType": "CustomerSearchResultsConnection",
    "kind": "LinkedField",
    "name": "accountsearchforcustomer4",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "totalCount",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "CustomerSearchResult",
        "kind": "LinkedField",
        "name": "nodes",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "accountId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "accountName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "accountNum",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "contactLastName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "contactFirstName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "contactEmail",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "contactPhone",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "accountStatus",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "customerStatus",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "floatProblem",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "declineCount",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "lastDeclineReason",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "lastDeclineChargeAmount",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "soStatus",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "CustomerConnectedEntity",
            "kind": "LinkedField",
            "name": "connectedEntities",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "accountIntegrationId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "appName",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "appLogo",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "appLogoWide",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "entity",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "entityId",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/),
      (v9/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "CustomerSearchTableQuery",
    "selections": (v10/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v9/*: any*/),
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v5/*: any*/),
      (v8/*: any*/),
      (v7/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v6/*: any*/)
    ],
    "kind": "Operation",
    "name": "CustomerSearchTableQuery",
    "selections": (v10/*: any*/)
  },
  "params": {
    "cacheID": "5dcaccb83b9926fe36df8c229315bbf9",
    "id": null,
    "metadata": {},
    "name": "CustomerSearchTableQuery",
    "operationKind": "query",
    "text": "query CustomerSearchTableQuery(\n  $resellerAccountId: UUID!\n  $accountName: String!\n  $accountNumber: String!\n  $activeOnly: Int\n  $floatProblemOnly: Int\n  $outstandingSOOnly: Int\n  $orderBy: Int\n  $direction: Int\n  $first: Int\n  $offset: Int\n) {\n  accountsearchforcustomer4(reselleraccountid: $resellerAccountId, accountname: $accountName, accountnumber: $accountNumber, activeonly: $activeOnly, floatproblemonly: $floatProblemOnly, outstandingsoonly: $outstandingSOOnly, orderby: $orderBy, direction: $direction, first: $first, offset: $offset) {\n    totalCount\n    nodes {\n      accountId\n      accountName\n      accountNum\n      contactLastName\n      contactFirstName\n      contactEmail\n      contactPhone\n      accountStatus\n      customerStatus\n      floatProblem\n      declineCount\n      lastDeclineReason\n      lastDeclineChargeAmount\n      soStatus\n      connectedEntities {\n        accountIntegrationId\n        appName\n        appLogo\n        appLogoWide\n        entity\n        entityId\n      }\n    }\n  }\n}\n"
  }
};
})();

node.hash = "86f7796d86aade8d6b018840028faff1";

module.exports = node;
